import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Image } from "primereact/image";
import { FaFile } from "react-icons/fa6";
import useGetToken from "../../../store/selectors/get-token";
import useGetQuoteHealthDetails from "../../../store/selectors/get-quote-health-details";
import useGetHealthPlan from "../../../store/selectors/get-health-plan-quote";
import useGetOrderDetailsId from "../../../store/selectors/get-order-details";

import useStorHealthPlanQuote from "../../../store/actions/store-health-plan-quote";
import useStoreQuoteHealthDetails from "../../../store/actions/store-quote-health-details";
import useStoreHealthQuestionnaire from "../../../store/actions/store-health-questionnaire";

import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import {
  createOrder,
  // createPolicy,
  initiatePayment,
  updateHealthEntry,
} from "../../../utils/backend";
import { useTranslation } from 'react-i18next';

const HealthPaymentPage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorVisible, setIsErrorVisible] = useState(false);
  const showErrorMessage = (msg) => {
    setErrorMessage(msg);
    setIsErrorVisible(true);
  };
  const token = useGetToken();
  const healthPlanQuote = useGetHealthPlan();
  const getOrderDetails = useGetOrderDetailsId();
  const getQuoteHealthDetails = useGetQuoteHealthDetails();
  const [comm, setComm] = useState(0);
  const [sst, setSst] = useState(0);
  const [subtotal, setSubtotal] = useState(0);
  const [totalPay, setTotalPay] = useState(0);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);

  const clearHealthPlan = useStorHealthPlanQuote();
  const clearHealthQuotes = useStoreQuoteHealthDetails();
  const clearHealthQuestionnaire = useStoreHealthQuestionnaire();

  const clearCacheAndState = () => {
    // Clear Redux store
    clearHealthPlan(null);
    clearHealthQuotes(null);
    clearHealthQuestionnaire(null);

    // Clear localStorage
    const cacheKeys = [
      "backImageID",
      "frontImageID",
      "frontImagePassport",
      "declarationOne",
      "declarationTwoA1",
      "declarationTwoA2",
      "healthAgreement",
      "nominees",
      "quoteHealthDetails",
    ];
    cacheKeys.forEach((key) => localStorage.removeItem(key));
    };

  useEffect(() => {
    const calculateSubtotal = () => {
      const premium = healthPlanQuote?.premium || 0;

      const commission = (parseFloat(premium) * 0.15).toFixed(2);
      const sst = (parseFloat(premium) * 0.08).toFixed(2);
      const stampDuty = (10).toFixed(2);

      let commissionFloat = parseFloat(commission).toFixed(2);
      let sstFloat = parseFloat(sst).toFixed(2);
      let stampDutyFloat = parseFloat(stampDuty).toFixed(2);

      let stotal = (
        parseFloat(commissionFloat) +
        parseFloat(sstFloat) +
        parseFloat(stampDutyFloat)
      ).toFixed(2);
      let total = (parseFloat(premium) + parseFloat(stotal)).toFixed(2);

      setComm(parseFloat(commissionFloat));
      setSst(parseFloat(sstFloat));
      setSubtotal(stotal);
      setTotalPay(total);
    };

    calculateSubtotal();
  }, [healthPlanQuote]);

  const submitHealthPayment = async () => {
    setLoading(true);

    try {
      let payload_update;
      payload_update = {
        health_id: getOrderDetails?.productId,
        health_data: {
          basic_premium: parseFloat(healthPlanQuote?.premium) || 0,
          sst_amount: sst,
          sst_percent: parseFloat(8),
          stamp_duty: parseFloat(10),
          discount_amount: parseFloat(0),
          discount_percent: parseFloat(0),
          commission_amount: parseFloat(comm),
          commission_percent: parseFloat(15),
          quoted_amount: parseFloat(totalPay),
        },
      };

      const update_entry = await updateHealthEntry(token, payload_update);
      if (update_entry && update_entry.success) {
        const payloads = {
          order_type: "product",
          insurance_type: 3,
          enquiry_id: getOrderDetails.productId,
          full_name: getQuoteHealthDetails?.policy_holder_name,
          insurance_plan: healthPlanQuote?.plan_name,
          insurer_name: healthPlanQuote?.company_name,
          order_status: "Pending Payment",
          order_date: "",
          order_value: totalPay,
          payment_status: "Pending",
        };
        const response = await createOrder(token, payloads);
				
        if (response && response.success) {
          // const today = new Date();
          // today.setHours(today.getHours() + 8);

          // const inception_date = today.toISOString().split("T")[0];
          // const expiry_date = new Date(today);
          // expiry_date.setFullYear(expiry_date.getFullYear() + 1);
          // expiry_date.setDate(expiry_date.getDate() - 1);
          // const expired_date = expiry_date.toISOString().split("T")[0];

          if (response?.data && response?.data?.orderId) {
            // const order_id = response?.data?.orderId;
            const orderNumber = response?.data?.orderNumber;

            // const policy_data = {
            //   subscription_plan_name: healthPlanQuote?.plan_name,
            //   status: "Pending",
            //   effective_date: inception_date,
            //   expiration_date: expired_date,
            //   policy_start_date: inception_date,
            //   policy_end_date: expired_date,
            //   order_id: order_id,
            // };

            // const policy = await createPolicy(token, policy_data);

            // if (policy && policy.success) {
            //   if (policy?.data && policy?.data?.id) {
                const paymentResponse = await initiatePayment(
                  token,
                  orderNumber
                );

                if (paymentResponse) {
                  // Create a container element to hold the HTML content
                  const container = document.createElement("div");
                  container.innerHTML = paymentResponse;

                  // Append the container to the body
                  document.body.appendChild(container);

                  // Find the form and submit it
                  const form = container.querySelector("#ipay88Form");
									
                  if (form) {
                    form.submit();
                  } else {
										setLoading(false);
                    showErrorMessage(`${t('messages.formNotFound')}`);
                  }
                } else {
									setLoading(false);
                  showErrorMessage(`${t('messages.failedToRetrievePaymentScript')}`);
                }
            //   }
            // }
          } else {
						setLoading(false);
            showErrorMessage(`${t('messages.unableToCreateOrder')}`);
          }
        }
      }
    } catch (error) {
			setLoading(false);
      showErrorMessage(`${t("common.error")}: ` + error.message);
    }
    clearCacheAndState();
  };

  if (loading) {
    return (
      <div className="content">
        <div className="get-quote-process-container">
          <div className="d-flex w-100"></div>
          <div className="text-center py-4">
            <i className="pi pi-spinner pi-spin"></i>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="content">
        <div className="get-quote-process-container">
          <div className="d-flex w-100">
            <h3>{`${t("healthInsurance.healthPayment.title")}`}</h3>
            <div className="car-details-block border-radius-25 p-20 w-100">
              <div className="grid w-100">
                <div className="col-lg-6 text-left p-10">
                  <h4>{`${healthPlanQuote?.company_name || ""} - 1 ${t("common.year")}`}</h4>
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="formatted-text">
                        {`${t("healthInsurance.healthPayment.protectionType")}`}
                      </span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`${t("healthInsurance.healthPayment.health")}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="formatted-text">{`${t("healthInsurance.healthPayment.basicPremium")}`}</span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`RM ${formatCurrency(
                        healthPlanQuote?.premium
                      )}`}</span>
                    </div>
                  </div>

                  <hr className="" />
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="color-heading fw-bold">
                        {`${t("healthInsurance.healthPayment.totalPremium")}`}
                      </span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="color-heading fw-bold">{`RM ${formatCurrency(
                        healthPlanQuote?.premium
                      )}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center py-2">
                    <div className="w-50 text-left">
                      <span className="formatted-text">{`${t("healthInsurance.healthPayment.rebate")}`}</span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`RM ${formatCurrency(
                        0
                      )}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center py-2">
                    <div className="w-50 text-left">
                      <span className="formatted-text">{`${t("healthInsurance.healthPayment.intermediariesCommission")} (${parseFloat(
                        15
                      )}%)`}</span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`RM ${formatCurrency(
                        healthPlanQuote?.premium * 0.15
                      )}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="formatted-text">{`${t("healthInsurance.healthPayment.serviceTax")} (8%)`}</span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`RM ${formatCurrency(
                        healthPlanQuote?.premium * 0.08
                      )}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="formatted-text">{`${t("healthInsurance.healthPayment.stampDuty")}`}</span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="fw-regular">{`RM ${formatCurrency(
                        10
                      )}`}</span>
                    </div>
                  </div>

                  <hr className="" />
                  <div className="d-flex justify-content-between align-items-center pb-2">
                    <div className="vw-50 text-left">
                      <span className="color-heading fw-bold">
                        {`${t("healthInsurance.healthPayment.subTotal")}`}
                      </span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="color-heading fw-bold">{`RM ${subtotal}`}</span>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center py-2">
                    <div className="vw-50 text-left">
                      <span className="fw-bold fs-lg">
                        {`${t("healthInsurance.healthPayment.totalPayableAmount")}`}
                      </span>
                    </div>
                    <div className="vw-50 text-right">
                      <span className="color-heading fw-bold fs-lg">{`RM ${formatCurrency(
                        totalPay
                      )}`}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="car-details-block border-radius-25 p-20 my-4 w-100">
              <div className="grid w-100">
                <div className="col-lg-6 text-left p-10">
                  <h4 className="my-2 mt-4">{`${t("healthInsurance.healthPayment.insurancePackage")}`}</h4>
                  <hr />
                  <div className="w-50">
                    {healthPlanQuote?.image_url && (
                      <Image
                        width="100%"
                        height="auto"
                        src={healthPlanQuote?.image_url}
                        alt={healthPlanQuote?.insurer_name}
                        style={{
                          maxWidth: "150px",
                          height: "auto",
                          display: "block",
                          margin: "0",
                        }}
                      />
                    )}
                  </div>

                  <div className="d-flex flex-row gap-2 pb-2">
                    <div className="d-flex gap-2 bg-light-primary border-radius-5 p-10">
                      <FaFile className="primary" />
                      <a
                        href={healthPlanQuote?.product_disclosure_sheet}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="color-primary text-decoration-none"
                      >
                        {`${t("healthInsurance.healthPayment.productDisclosureSheet")}`}
                      </a>
                    </div>
                  </div>

                  <div className="row justify-content-between mx-0">
                    <div className="col-lg-6 col-sm-6 input-group text-left">
                      <p className="formatted-text m-0">{`${t("healthInsurance.healthPayment.protectionType")}`}</p>
                      <p className="m-0">{`${t("healthInsurance.healthPayment.premium")}`}</p>
                    </div>

                    <div className="col-lg-6 col-sm-6 input-group text-left">
                      <p className="formatted-text m-0">{`${t("healthInsurance.healthPayment.includedRoomAndBoard")}`}</p>
                      <p className="m-0">{`RM ${getQuoteHealthDetails?.room_board} ${t("healthInsurance.selectHealthPlan.perNight")}`}</p>
                    </div>
                  </div>

                  <div className="row justify-content-between mx-0">
                    <div className="col-lg-6 col-sm-6 input-group text-left">
                      <p className="formatted-text m-0">{`${t("healthInsurance.selectHealthPlan.filters.preHospitalisation")}`}</p>
                      <p className="m-0">{`${healthPlanQuote?.pre_hospitalisation} ${t("healthInsurance.selectHealthPlan.filters.days")}`}</p>
                    </div>

                    <div className="col-lg-6 col-sm-6 input-group text-left">
                      <p className="formatted-text m-0">{`${t("healthInsurance.selectHealthPlan.filters.postHospitalisation")}`}</p>
                      <p className="m-0">{`${healthPlanQuote?.post_hospitalisation} ${t("healthInsurance.selectHealthPlan.filters.days")}`}</p>
                    </div>
                  </div>

                  <div>
                    <span className="fw-medium formatted-text py-4">{`${t("healthInsurance.healthPayment.fullReimbursement")}`}</span>
                    <ul>
                      {healthPlanQuote?.kidney_dialysis ===
                        "Full Reimbursement" && (
                        <li>{`${t("healthInsurance.selectHealthPlan.outPatientKidneyDialysisTreatment")}`}</li>
                      )}
                      {healthPlanQuote?.cancer_treatment ===
                        "Full Reimbursement" && (
                        <li>{`${t("healthInsurance.selectHealthPlan.outPatientCancerTreatment")}`}</li>
                      )}
                    </ul>
                  </div>

                  <div>
                    <span className="fw-medium formatted-text py-4">{`${t("healthInsurance.healthPayment.limits")}:`}</span>
                    <ul>
                      <li>{`${t("common.upTo")} RM ${healthPlanQuote?.annual_limit} ${t("common.annualLimit")}`}</li>
                      <li>
                        {healthPlanQuote.lifetime_limit === "0.00"
                          ? `${t("common.noLifetimeLimit")}`
                          : `${t("common.upTo")} RM ${healthPlanQuote?.lifetime_limit} ${t("common.lifetimeLimit")}`}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <Button
              label={`${t("healthInsurance.healthPayment.payNow")} (7/7)`}
              className="btn-primary mt-4"
              onClick={submitHealthPayment}
              loading={loading}
            />
            {/* BottomMessagePopUp Component */}
            <BottomMessagePopUp
              message={errorMessage}
              type="error"
              isVisible={isErrorVisible}
              onClose={() => setIsErrorVisible(false)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default HealthPaymentPage;
